import React from 'react'

const WithdrawalsPage = () => {
  return (
    <div>WithdrawalsPage</div>
  )
}

export default WithdrawalsPage;